import { render, staticRenderFns } from "./contraseniaComponent.vue?vue&type=template&id=c532e070"
import script from "./contraseniaComponent.vue?vue&type=script&lang=js"
export * from "./contraseniaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports